<template>
  <v-container>
      <v-form ref="form">
          <v-row class="mt-4 d-flex justify-center align-center">
            <v-col cols="4">
              <v-autocomplete
                v-model="content.origemId"
                label="Origem*"
                outlined
                dense
                :items="origensFiltradas"
                item-text="nome"
                item-value="id"
                :disabled="camposDesabilitados"
                return-object
                :rules="[$required]"
                @change="verificarOrigemSelecionada"
              />
            </v-col>
          </v-row>
          <v-row class="mt-4">
            <v-col :cols="mostrarNomeGre && mostrarEscola ? 6 : 12" v-if="mostrarNomeGre">
              <v-autocomplete
                  v-model="content.greId"
                  label="Nome da GRE*"
                  dense
                  outlined
                  item-text="nome"
                  item-value="codigo"
                  return-object
                  :items="listaGerenciasRegionais"
                  @focus="ensureGerenciasLoaded"
                  @change="atualizarGreIds"
                  :rules="[$required]"
                  :disabled="camposDesabilitados"
              />
            </v-col>
            <v-col v-if="mostrarEscola">
              <v-autocomplete
                  v-model="content.escolaId"
                  label="Escola*"
                  dense
                  outlined
                  item-text="nome"
                  item-value="codigo"
                  multiple
                  return-object
                  :items="listarEscolas"
                  :rules="[$required]"
                  :disabled="!liberarEscola || camposDesabilitados"

              />
            </v-col>
            <v-col cols="12" v-if="mostrarSecretariaExecutiva">
                <v-autocomplete
                    v-model="content.secretariaId"
                    label="Secretaria Executiva*"
                    dense
                    outlined
                    :items="listaSecretarias"
                    item-text="nome"
                    item-value="codigo"
                    multiple
                    return-object
                    @focus="ensureSecretariasLoaded"
                    :rules="[$required]"
                    :disabled="camposDesabilitados"
                />
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center mt-7">
              <sigfoco-date-picker
                v-model="content.dataInicio"
                label="Início da Formação*"
                removeIcon
                :dataEdicao="content.dataInicio"
                outlined
                dense
                :rules="[
                  $required,
                  () => validateData() || 'A data de início da formação não pode ser posterior à data de fim da formação.'
                ]"
                :disabled="camposDesabilitados"
              ></sigfoco-date-picker>
              <sigfoco-date-picker
                v-model="content.dataFim"
                label="Final da Formação*"
                removeIcon
                :dataEdicao="content.dataFim"
                outlined
                dense
                :rules="[
                  $required,
                  () => validateData() || 'A data de fim da formação não pode ser anterior à data de início da formação.'
                ]"
                :disabled="camposDesabilitados"
              ></sigfoco-date-picker>
            </v-row>
          <div>
            <v-card class="pa-4 mt-3" outlined>
              <h3>Formação Continuada para (Público Alvo):</h3>
              <v-divider></v-divider>

              <v-row class="mt-4">
                <v-col cols="4">
                  <v-autocomplete
                    v-model="content.funcaoId"
                    label="Função*"
                    outlined
                    dense
                    :items="funcoes"
                    item-text="nome"
                    item-value="id"
                    :disabled="camposDesabilitados"
                    :rules="[$required]"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    id="etapaDeEnsinoId"
                    v-model="content.etapaDeEnsinoId"
                    label="Etapa de Ensino*"
                    outlined
                    dense
                    :items="listaEtapas"
                    item-text="nome"
                    item-value="id"
                      @focus="ensureEtapasLoaded"
                    :disabled="camposDesabilitados"
                    :rules="[$required]"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    v-if="deveExibirCampoDisciplina"
                    v-model="content.disciplinaId"
                    label="Disciplina*"
                    outlined
                    dense
                    :items="disciplinas"
                    item-text="nomeDisciplina"
                    item-value="id"
                    @focus="ensureDisciplinasLoaded"
                    :disabled="camposDesabilitados"
                    :rules="[$required]"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-3">
                <v-col cols="12">
                  <v-text-field
                    v-model="content.nomeDaAcao"
                    label="Nome da ação*"
                    counter="200"
                    maxlength="200"
                    dense
                    outlined
                    :rules="[$required]"
                    :disabled="camposDesabilitados"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-3">
                <v-col cols="6">
                  <v-textarea
                    v-model="content.objetivoGeral"
                    label="Objetivo Geral*"
                    counter="500"
                    maxlength="500"
                    placeholder="Informe o objetivo geral"
                    outlined
                    dense
                    :disabled="camposDesabilitados"
                    :rules="[$required]"
                  />
                </v-col>
                <v-col cols="6">
                  <v-textarea
                    v-model="content.objetivoEspecifico"
                    label="Objetivos Específicos*"
                    placeholder="Informe os objetivos específicos"
                    counter="500"
                    maxlength="500"
                    outlined
                    dense
                    :disabled="camposDesabilitados"
                    :rules="[$required]"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-3">
                <v-col cols="12">
                  <v-text-field
                    v-model="content.localRealizacao"
                    label="Local de Realização*"
                    counter="200"
                    maxlength="200"
                    dense
                    outlined
                    :rules="[$required]"
                    :disabled="camposDesabilitados"
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-card class="pa-4 mt-3" outlined>
              <h3>Turmas:</h3>
              <v-divider></v-divider>

              <v-row class="mt-3">
                <v-col cols="3">
                  <v-text-field
                    label="Turma"
                    v-model="content.nomeTurma"
                    outlined
                    counter="50"
                    maxlength="50"
                    dense
                    :disabled="camposDesabilitados"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-autocomplete
                    v-model="content.turnoId"
                    label="Turno"
                    dense
                    outlined
                    :items="listaTurnos"
                    item-text="descricao"
                    item-value="turnoId"
                    return-object
                    @focus="ensureTurnosLoaded"
                    :disabled="camposDesabilitados"
                    @change="validarHorarioTurno"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Horário Início"
                    ref="formHoraInicio"
                    v-model="content.horaInicio"
                    outlined
                    dense
                    maxlength="5"
                    @keypress="$validarEntradaNumerica"
                    @input="formatarHoraInput('horaInicio', $event)"
                    :rules="[
                      (h) => horaValida(h),
                      (h) => validarFormatoHora(h) || 'O horário deve ser no formato HH:MM',
                      (h) => horaNoTurnoEspecificado(h)
                    ]"
                    :disabled="camposDesabilitados"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Horário Final"
                    ref="formHoraFinal"
                    v-model="content.horaTermino"
                    outlined
                    :disabled="camposDesabilitados"
                    dense
                    @keypress="$validarEntradaNumerica"
                    maxlength="5"
                    @input="formatarHoraInput('horaTermino', $event)"
                    :rules="[
                      (h) => horaValida(h),
                      (h) => validarFormatoHora(h) || 'O horário deve ser no formato HH:MM',
                      (h) => horaNoTurnoEspecificado(h)
                    ]"
                  ></v-text-field>
                </v-col>
                <sigfoco-date-picker
                :cols="3"
                v-model="content.dataRealizacao"
                label="Data"
                removeIcon
                :dataEdicao="content.dataRealizacao"
                outlined
                dense
                :disabled="camposDesabilitados"
              ></sigfoco-date-picker>

                <!-- Botão Incluir -->
                <v-col cols="12" class="text-center">
                  <v-btn color="primary" @click="adicionarAtualizarTurma"  :disabled="!podeAdicionarTurma || camposDesabilitados">
                    <v-icon left>mdi-plus</v-icon> Incluir
                  </v-btn>
                </v-col>

                <!-- Tabela -->
                <v-col cols="12">
                  <v-data-table
                    class="mt-5"
                    dense
                    :headers="headers"
                    :items="content.relacaoTurmas"
                    :items-per-page="10"
                    :footer-props="$footerProps"
                  >
                    <template v-slot:[`item.nomeTurma`]="{ item }">
                      {{ item.nomeTurma }}
                    </template>
                    <template v-slot:[`item.nomeTurno`]="{ item }">
                      {{ item.nomeTurno }}
                    </template>
                    <template v-slot:[`item.dataRealizacao`]="{ item }">
                      {{ $formatarData(item.dataRealizacao) }}
                    </template>
                    <template v-slot:[`item.horaInicio`]="{ item }">
                      {{ formatarHora(item.horaInicio) }}
                    </template>
                    <template v-slot:[`item.horaTermino`]="{ item }">
                      {{ formatarHora(item.horaTermino) }}
                    </template>
                    <template v-slot:[`item.acoes`]="{ item, index }">
                      <div :key="index">
                        <sigfoco-tooltip
                          :text="'Editar'"
                          :icon="'mdi-pencil'"
                          :small="true"
                          :disabled="camposDesabilitados"
                          @click="editarTurma(item, index)"
                        ></sigfoco-tooltip>
                        <sigfoco-tooltip
                          :text="'Excluir'"
                          :icon="'mdi-delete'"
                          :small="true"
                          :disabled="camposDesabilitados"
                          @click="excluirTurma(item)"
                        ></sigfoco-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="pa-4 mt-3" outlined>
              <v-row class="mt-3">
                <v-col cols="4">
                  <v-text-field
                    label="Número Total de Participantes*"
                    v-model="content.numeroTotalParticipantes"
                    outlined
                    counter="4"
                    maxlength="4"
                    inputmode="numeric"
                    dense
                    @keypress="$validarEntradaNumerica"
                    :rules="[$required]"
                    :disabled="camposDesabilitados"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="Quantidade de Turmas"
                    v-model="content.quantidadeDeTurmas"
                    outlined
                    couter="15"
                    maxlength="15"
                    dense
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="Carga Horária*"
                    v-model="content.cargaHoraria"
                    outlined
                    counter="6"
                    type="text"
                    dense
                    :rules="[$required, validarFormatoCargaHoraria]"
                    :disabled="camposDesabilitados"
                    @input="formatarCargaHoraria"
                    />
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-textarea
                    v-model="content.conteudoProgramatico"
                    label="Conteúdo Programático*"
                    maxlength="1000"
                    counter="1000"
                    dense
                    outlined
                    rows="6"
                    :rules="[$required]"
                    :disabled="camposDesabilitados"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-textarea
                    v-model="content.metodologiaDeEnsino"
                    label="Metodologia de Ensino*"
                    maxlength="1000"
                    counter="1000"
                    dense
                    outlined
                    rows="6"
                    :rules="[$required]"
                    :disabled="camposDesabilitados"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-textarea
                    v-model="content.recursosUtilizados"
                    label="Recursos Utilizados*"
                    maxlength="500"
                    counter="500"
                    dense
                    outlined
                    rows="6"
                    :rules="[$required]"
                    :disabled="camposDesabilitados"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="pa-4 mt-3" outlined>
              <h3>Instrutoria e Coordenação:</h3>
              <v-divider></v-divider>
              <v-row class="mt-3">
                <v-col cols="4">
                  <v-text-field
                    label="Nome Completo do Coordenador"
                    v-model="content.nomeDoCoordenador"
                    outlined
                    dense
                    maxlength="40"
                    counter="40"
                    :disabled="camposDesabilitados"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                  label="Matrícula"
                  v-model="content.matriculaDoCoordenador"
                  outlined
                  maxlength="12"
                  counter="12"
                  hint="A matrícula do servidor deve conter 12 números."
                  persistent-hint
                  dense
                  @keypress="$validarEntradaNumerica"
                  inputmode="numeric"
                  :disabled="camposDesabilitados"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="CPF"
                    v-model="content.cpfDoCoordenador"
                    outlined
                    maxlength="14"
                    counter="14"
                    dense
                    @keypress="$validarEntradaNumerica"
                    v-mask="'###.###.###-##'"
                    @input="formatarCpfOnInput('cpfDoCoordenador', $event)"
                    :disabled="camposDesabilitados"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn color="primary" @click="adicionarAtualizarCoordenador" :disabled="!podeAdicionarCoordenador || camposDesabilitados">
                    <v-icon left>mdi-plus</v-icon> Incluir Coordenador
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-col cols="12">
                  <v-data-table
                    class="mt-5"
                    dense
                    :headers="headersCoordenadores"
                    :items="content.coordenadores"
                    :items-per-page="10"
                    :footer-props="$footerProps"
                  >
                    <template v-slot:[`item.nomeDoCoordenador`]="{ item }">
                      {{ item.nomeDoCoordenador }}
                    </template>
                    <template v-slot:[`item.matriculaDoCoordenador`]="{ item }">
                      {{ item.matriculaDoCoordenador }}
                    </template>
                    <template v-slot:[`item.cpfDoCoordenador`]="{ item }">
                      {{ $esconderCpf(item.cpfDoCoordenador) }}
                    </template>
                    <template v-slot:[`item.acoes`]="{ item, index }">
                      <div :key="index">
                        <sigfoco-tooltip
                          :text="'Editar'"
                          :icon="'mdi-pencil'"
                          :small="true"
                          :disabled="camposDesabilitados"
                          @click="editarCoordenador(item, index)"
                        ></sigfoco-tooltip>
                        <sigfoco-tooltip
                          :text="'Excluir'"
                          :icon="'mdi-trash-can-outline'"
                          :small="true"
                          :disabled="camposDesabilitados"
                          @click="excluirCoordenador(item)"
                        ></sigfoco-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="mt-3">
                <v-col cols="4">
                  <v-text-field
                    label="Nome Completo do Instrutor"
                    v-model="content.nomeDoInstrutor"
                    outlined
                    dense
                    counter="40"
                    maxlength="40"
                    :disabled="camposDesabilitados"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="Matrícula"
                    v-model="content.matriculaDoInstrutor"
                    outlined
                    dense
                    maxlength="12"
                    minlength="12"
                    counter="12"
                    hint="A matrícula do servidor deve conter 12 números."
                    persistent-hint
                    @keypress="$validarEntradaNumerica"
                    inputmode="numeric"
                    :disabled="camposDesabilitados"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="CPF"
                    v-model="content.cpfDoInstrutor"
                    outlined
                    maxlength="14"
                    counter="14"
                    dense
                    v-mask="'###.###.###-##'"
                    @keypress="$validarEntradaNumerica"
                    @input="formatarCpfOnInput('cpfDoInstrutor', $event)"
                    :disabled="camposDesabilitados"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn color="primary" @click="adicionarAtualizarInstrutor" :disabled="!podeAdicionarInstrutor || camposDesabilitados">
                    <v-icon left>mdi-plus</v-icon> Incluir Instrutor
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-col cols="12">
                  <v-data-table
                    class="mt-5"
                    dense
                    :headers="headersInstrutores"
                    :items="content.instrutores"
                    :items-per-page="10"
                    :footer-props="$footerProps"
                  >
                    <template v-slot:[`item.nomeDoInstrutor`]="{ item }">
                      {{ item.nomeDoInstrutor }}
                    </template>
                    <template v-slot:[`item.matriculaDoInstrutor`]="{ item }">
                      {{ item.matriculaDoInstrutor }}
                    </template>
                    <template v-slot:[`item.cpfDoInstrutor`]="{ item }">
                      {{ $esconderCpf(item.cpfDoInstrutor) }}
                    </template>
                    <template v-slot:[`item.acoes`]="{ item, index }">
                      <div :key="index">
                        <sigfoco-tooltip
                          :text="'Editar'"
                          :icon="'mdi-pencil'"
                          :small="true"
                          :disabled="camposDesabilitados"
                          @click="editarInstrutor(item, index)"
                        ></sigfoco-tooltip>
                        <sigfoco-tooltip
                          :text="'Excluir'"
                          :icon="'mdi-trash-can-outline'"
                          :small="true"
                          :disabled="camposDesabilitados"
                          @click="excluirInstrutor(item)"
                        ></sigfoco-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Valor Total de Investimento*"
                    v-model="content.valorTotalInvestimento"
                    outlined
                    dense
                    type="text"
                    @keypress="$validarEntradaNumerica"
                    @input="formatarValor"
                    :rules="[$required]"
                    :disabled="camposDesabilitados"
                    maxlength="21"
                    counter="21"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="content.avaliacaoId"
                    label="Escolha a avaliação que os participantes responderão sobre a formação*"
                    outlined
                    dense
                    :items="avaliacoes"
                    item-text="avaliacao"
                    item-value="id"
                    @focus="ensureAvaliacoesLoaded"
                    :disabled="camposDesabilitados"
                    :rules="[$required]"
                  />
                </v-col>
              </v-row>
              <div v-if="!isFormador && qtdAjustes >=3 && !isViewMode" class="alert-message d-flex align-center mt-4">
                <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
                <span>Esta Solicitação de Formação já sofreu três ajustes. Não é possível realizar mais alterações.</span>
              </div>
              <v-row class="mt-3" v-if="situacaoParaExibirComentario">
                <v-col cols="12">
                    <v-textarea
                    v-model="content.comentario"
                    label="Comentário"
                    maxlength="400"
                    counter="400"
                    dense
                    outlined
                    rows="6"
                    :disabled="isViewMode || qtdAjustes >= 3 || isReenviar()"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row v-if="!isFormador">
                  <v-col cols="12">
                    <p><b>{{ content.ultimaAtualizacao }}</b></p>
                  </v-col>
                </v-row>
            </v-card>
          </div>
          <v-row class="d-block text-center btn-group">
              <v-col cols="12">
                  <v-btn v-if="!isViewMode && isFormador" color="primary" class="ml-2" @click="salvar(false)">
                      Salvar
                  </v-btn>
                  <v-btn v-if="!isViewMode && isFormador && !situacaoParaExibirComentario" color="primary" class="ml-2" @click="salvar(true)">
                      <v-icon v-if="actionIcon">{{ actionIcon }}</v-icon> {{ edit ? 'Editar e Avançar' : 'Salvar e Avançar' }}
                  </v-btn>
                  <v-btn v-if="isFormadorOrAdm && !isViewMode && formacaoIdAtual && situacaoParaExibirComentario" color="primary" class="ml-2" @click="solicitarCorrecao">
                    Salvar e Avançar
                  </v-btn>
                  <v-btn v-if="!isViewMode" color="primary" outlined class="ml-2" @click="cancelar">
                      {{ isReenviar() ? 'Cancelar':'Fechar' }}
                  </v-btn>
                  <v-btn v-if="isViewMode" color="primary" outlined class="ml-2" @click="avancar">
                    Avançar
                  </v-btn>
                  <v-btn v-if="isViewMode" color="primary" outlined class="ml-2" @click="cancelar">
                    Fechar
                  </v-btn>
              </v-col>
          </v-row>
      </v-form>
  </v-container>
</template>
  
  <script>
  import { DialogPropsFormacao } from '~/commons/classes/dialog-props-formacao';
  import { Formacao } from '~/commons/classes/formacao';
  import ManterSetorService from "~/services/manter-setor.service";
  import ManterFuncoesService from "~/services/manter-funcao.service";
  import ManterDisciplinaService from "~/services/manter-disciplina.service";
  import FormacaoService from "~/services/manter-formacao.service";
  import AuthService from "~/services/auth.service";
  import { globalStore }from "~/mixins/global-formacao.mixin";
  import { AUTH_NAMESPACE, USER, LOGIN, ABILITIES } from 'store/modules/auth';
  import ManterAvaliacaoFormacaoService from '~/services/manter-avaliacao-formacao';
  import CacheService from '~/services/cache.service';

  export default {
    name: "AbaPlanoDeTrabalho",
    props: new DialogPropsFormacao(Formacao),
    mixins: [FormacaoService, ManterSetorService, ManterFuncoesService, ManterDisciplinaService, AuthService, ManterAvaliacaoFormacaoService],
    data: () => ({
        actionIcon: '',
        origens: [],
        funcoes: [],
        disciplinas: [],
        avaliacoes: [],
        coordenadores: [],
        instrutores:[],
        listaGerenciasRegionais: [],
        listarEscolas: [],
        listaSecretarias: [],
        listaTurnos: [],
        listaEtapas: [],
        selectedGreCodes: [],
        relacaoTurmas: [],
        mostrarNomeGre: false,
        mostrarSecretariaExecutiva: false,
        mostrarEscola: false,
        liberarEscola:false,
        turmaEditandoIndex: null,
        coordenadorEditandoIndex: null,
        instrutorEditandoIndex: null,
        jaSofreuTresAjustes: false,
        qtdAjustes: 0,
        comentarioInicial: null,
        isInitializing: true,
        isLoadingDisciplinas: false,
        isLoadingGerencias: false,
        isLoadingSecretarias: false,
        isLoadingAvaliacoes: false,
        isLoadingTurnos: false,
        isLoadingEtapas: false,
        horariosPermitidosPorTurno: [
          { descricao: 'Manhã', inicio: '07:00', fim: '12:00' },
          { descricao: 'Tarde', inicio: '13:00', fim: '18:00' },
          { descricao: 'Noite', inicio: '19:00', fim: '22:00' },
          { descricao: 'Integral', inicio: '07:00', fim: '18:00' },
        ],
        headers: [
          { text: "Turma", align: "center", value: "nomeTurma" },
          { text: "Turno", align: "center", value: "nomeTurno" },
          { text: "Data", align: "center", value: "dataRealizacao" },
          { text: "Horário Inicial", align: "center", value: "horaInicio" },
          { text: "Horário Final", align: "center", value: "horaTermino" },
          { text: "Ações", align: "center", value: "acoes", sortable: false },
        ],
        headersInstrutores: [
          { text: "Nome Completo do Instrutor", align: "center", value: "nomeDoInstrutor" },
          { text: "Matrícula", align: "center", value: "matriculaDoInstrutor" },
          { text: "CPF", align: "center", value: "cpfDoInstrutor" },
          { text: "Ações", align: "center", value: "acoes", sortable: false },
        ], 
        headersCoordenadores: [
          { text: "Nome Completo do Coordenador", align: "center", value: "nomeDoCoordenador" },
          { text: "Matrícula", align: "center", value: "matriculaDoCoordenador" },
          { text: "CPF", align: "center", value: "cpfDoCoordenador" },
          { text: "Ações", align: "center", value: "acoes", sortable: false },
        ],
        funcoesComDisciplina: ['Professor', 'Técnico Formador'],
      }
    ),
    created() {
      if (globalStore.dadosPlanoDeTrabalho) {
          this.preencherCampos();
      }
    },
    watch: {
      'content.relacaoTurmas': {
        handler(novaLista) {
          this.$set(this.content, 'quantidadeDeTurmas', novaLista?.length || 0);
        },
        deep: true,
        immediate: true
      },
      "globalStore.idFormacaoAtual": {
        handler(novoId) {
            this.content.id = novoId;
        },
        immediate: true
      },
      // Carregar GREs quando mostrarNomeGre for ativado
      mostrarNomeGre(value) {
        if (this.isInitializing || !value) {
          return;
        }
        this.ensureGerenciasLoaded();
      },
      // Carregar secretarias quando mostrarSecretariaExecutiva for ativado
      mostrarSecretariaExecutiva(value) {
        if (this.isInitializing || !value) {
          return;
        }
        this.ensureSecretariasLoaded();
      },
      // Carregar disciplinas quando uma função que requer disciplina for selecionada
      'content.funcaoId'(newVal) {
        if (this.isInitializing || !newVal) {
          return;
        }
        if (this.deveExibirCampoDisciplina) {
          this.ensureDisciplinasLoaded();
        }
      }
    },
    computed: {
      $user() {
        // Computed local para garantir acesso correto ao usuário do store
        const user = this.$store.getters[`${AUTH_NAMESPACE}/${USER}`];
        const permissions = this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`];
        return {
          ...user,
          permissions
        };
      },
      isViewMode() {
        // Expõe o isViewMode do globalStore como computed
        return globalStore.isViewMode;
      },
      formacaoIdAtual() {
        // Expõe o idFormacaoAtual do globalStore como computed
        return globalStore.idFormacaoAtual;
      },
      isFormadorOrAdm() {
        // Verifica se o usuário possui simultaneamente:
        // 1. Algum perfil que contém 'formador'
        // 2. Algum perfil que contém 'adm' ou 'administrador'
        const roles = this.$user?.roles;
        if (!Array.isArray(roles) || roles.length === 0) {
          return false;
        }

        const perfis = roles.map((perfil) =>
          typeof perfil === 'string'
            ? perfil
            : perfil?.nome || perfil?.name || perfil?.descricao || perfil?.perfil || ''
        ).filter(Boolean);

        const possuiFormador = perfis.some((p) => p.toLowerCase().includes('formador'));
        const possuiAdmin = perfis.some((p) => p.toLowerCase().includes('administrador'));

        return possuiFormador || possuiAdmin;
      },
      isFormador() {
        // Verifica se o usuário tem algum perfil que contém 'formador'
        const roles = this.$user?.roles;
        if (!Array.isArray(roles) || roles.length === 0) {
          return false;
        }

        return roles.some((perfil) => {
          const perfilStr = typeof perfil === 'string'
            ? perfil
            : perfil?.nome || perfil?.name || perfil?.descricao || perfil?.perfil || '';

          return perfilStr.toLowerCase().includes('formador');
        });
      },
      situacaoEmRevisao() {
        return [2, 3, 9, 10].includes(globalStore.situacaoId);
      },
      situacaoParaExibirComentario() {
        return [2, 3, 6, 8, 9, 10].includes(globalStore.situacaoId);
      },
      camposDesabilitados() {
        // Campos são desabilitados quando:
        // 1. Está em modo visualização (isViewMode)
        // 2. Usuário NÃO é formador
        // 3. Situação é "Aguardando Aprovação" (2) ou "Aguardando Consolidação" (3)
        return this.isViewMode || !this.isFormador || this.situacaoEmRevisao;
      },
      contentGreId: {
        get() {
          return this.selectedGreCodes;
        },
        set(value) {
          this.selectedGreCodes = value;
        },
      },
      user() {
        return this.$store.getters[`${AUTH_NAMESPACE}/${USER}/${LOGIN}`];
      },
      origensFiltradas() {
        if (!this.origens || this.origens.length === 0) {
          return [];
        }

        const normalizarTexto = (valor) => String(valor || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();

        // Obter os perfis originais (sem normalização) e normalizados
        const perfisOriginais = (Array.isArray(this.$user?.roles) ? this.$user.roles : [])
          .map((perfil) => {
            if (typeof perfil === 'string') return perfil;
            if (perfil && typeof perfil === 'object') {
              return perfil.nome || perfil.name || perfil.descricao || perfil.perfil || '';
            }
            return '';
          })
          .filter(Boolean);

        const perfisNormalizados = perfisOriginais.map(normalizarTexto).filter(Boolean);

        // Verificar se tem perfil formador
        const possuiFormador = perfisNormalizados.some((perfil) => perfil.includes('formador'));

        // Verificar se tem perfil "Administrador" exato (super admin)
        const possuiSuperAdmin = perfisOriginais.some((perfil) => {
          const perfilTrimmed = String(perfil).trim();
          return perfilTrimmed === 'Administrador';
        });

        // REGRA 1: Se tem formador + super admin (perfil exato "Administrador") → libera todas as origens
        if (possuiFormador && possuiSuperAdmin) {
          return this.origens;
        }

        // REGRA 2 e 3: Formador + outros admins OU apenas formador → filtra pela origem do tipo de formador
        if (possuiFormador) {
          const possuiTermos = (...termos) =>
            perfisNormalizados.some((perfil) => termos.every((termo) => perfil.includes(termo)));

          const isFormadorEscola = possuiTermos('formador', 'escola');
          const isFormadorGre = possuiTermos('formador', 'gre');
          const isFormadorSee = possuiTermos('formador', 'see');

          const origensPermitidas = this.origens.filter((origem) => {
            const nomeOrigem = normalizarTexto(origem.nome);

            if (isFormadorEscola && nomeOrigem === 'escola') return true;
            if (isFormadorGre && nomeOrigem === 'gre') return true;
            if (isFormadorSee && nomeOrigem === 'see') return true;

            return false;
          });

          // Fallback para não bloquear cadastro quando o perfil vier em formato inesperado
          const origemBase = origensPermitidas.length ? origensPermitidas : this.origens;

          const origemSelecionadaId = this.content?.origemId?.id;
          if (origemSelecionadaId && !origemBase.some(origem => origem.id === origemSelecionadaId)) {
            return [...origemBase, this.content.origemId];
          }

          return origemBase;
        }

        // Se não tem perfil formador, retorna todas as origens (usuários não-formadores)
        return this.origens;
      },
      podeAdicionarTurma() {
        return !!(
          this.content.nomeTurma &&
          this.content.horaInicio &&
          this.content.horaTermino &&
          this.content.turnoId?.turnoId &&
          this.content.dataRealizacao
        );
      },
      podeAdicionarCoordenador() {
        return !!(
        this.content.matriculaDoCoordenador?.length === 12 &&
        this.content.cpfDoCoordenador &&
        this.content.nomeDoCoordenador
        );
      },
      podeAdicionarInstrutor() {
        return !!(
        this.content.matriculaDoInstrutor?.length === 12 &&
        this.content.cpfDoInstrutor &&
        this.content.nomeDoInstrutor
        );
      },
      turnoSelecionado() {
        return this.listaTurnos.find(item => item.turnoId === this.content.turnoId?.turnoId);
      },
      horarioPermitido() {
        return this.horariosPermitidosPorTurno.find(item => item.descricao === this.turnoSelecionado?.descricao);
      },
      funcaoSelecionada() {
        return this.funcoes.find(item => item.id === this.content.funcaoId);
      },
      deveExibirCampoDisciplina() {
        return this.funcoesComDisciplina.includes(this.funcaoSelecionada?.nome)
      },
    },
    methods: {
      sincronizarOrigemSelecionada() {
        const origemAtual = this.content?.origemId;
        if (!origemAtual || !this.origens?.length) {
          return;
        }

        const origemAtualId = origemAtual.id ?? origemAtual;
        if (!origemAtualId) {
          return;
        }

        const origemDaLista = this.origens.find(origem => origem.id === origemAtualId);
        if (origemDaLista) {
          this.content.origemId = origemDaLista;
        }

        this.verificarOrigemSelecionada();
      },
      inicializarOrigemPadrao() {
        if (this.content?.origemId) {
          return;
        }

        const opcoes = this.origensFiltradas;
        if (opcoes.length === 1) {
          this.content.origemId = opcoes[0];
          this.verificarOrigemSelecionada();
        }
      },
      async carregarDadosEssenciais() {
        try {
          // Carregar apenas dados críticos inicialmente usando cache
          const [origensResp, funcoesResp] = await Promise.all([
            CacheService.getOrFetch('formacao:origens',
              () => this.$buscarOrigens().catch(err => {
                console.error('Erro ao buscar origens:', err);
                return { data: { itens: [] } };
              })
            ),
            CacheService.getOrFetch('formacao:funcoes',
              () => this.$buscarFuncoes({origem: null}).catch(err => {
                console.error('Erro ao buscar funções:', err);
                return { data: { itens: [] } };
              })
            )
          ]);

          this.origens = origensResp.data?.itens || [];
          this.funcoes = funcoesResp.data?.itens?.filter(funcao => funcao?.ativo) || [];
          this.sincronizarOrigemSelecionada();
          this.inicializarOrigemPadrao();

          // Verificar limite de ajustes se necessário
          const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
          if (formacaoId && !this.isFormador) {
            this.$consultarStatusLimiteDeAjustes(formacaoId)
              .then(({ data }) => {
                this.jaSofreuTresAjustes = data.jaSofreuTresAjustes;
                this.qtdAjustes = data.qtdAjustes;
              })
              .catch(err => {
                console.error('Erro ao consultar limite de ajustes:', err);
              });
          }
        } catch (error) {
          console.error('Erro ao carregar dados essenciais:', error);
          this.$notifyError('Erro ao carregar dados do formulário. Tente novamente.');
        }
      },

      carregarDadosSecundarios() {
        // Carregar disciplinas apenas quando houver função que exija esse campo.
        const needsDisciplinas = this.content.funcaoId && this.deveExibirCampoDisciplina;
        if (needsDisciplinas) {
          CacheService.getOrFetch('formacao:disciplinas',
            () => this.$buscarDisciplina()
          )
            .then((resp) => {
              this.disciplinas = resp.data?.lista?.filter(disciplina => disciplina?.ativo) || [];
            })
            .catch(err => {
              console.error('Erro ao buscar disciplinas:', err);
            });
        }

        // Para edição/visualização, pré-carrega avaliações sempre
        this.ensureAvaliacoesLoaded();

        // Carregar GREs apenas se necessário
        if (this.mostrarNomeGre || this.content.greId) {
          CacheService.getOrFetch('formacao:gres',
            () => this.$obterListaGerenciasRegionais()
          )
            .then((resp) => {
              this.listaGerenciasRegionais = resp.data?.lista || [];
            })
            .catch(err => {
              console.error('Erro ao buscar GREs:', err);
            });
        }

        // Carregar secretarias apenas se necessário
        if (this.mostrarSecretariaExecutiva || this.content.secretariaId) {
          CacheService.getOrFetch('formacao:secretarias',
            () => this.$obterListaSecretarias()
          )
            .then((resp) => {
              this.listaSecretarias = resp.data?.lista || [];
            })
            .catch(err => {
              console.error('Erro ao buscar secretarias:', err);
            });
        }

        if (this.content.turnoId || (this.content.relacaoTurmas?.length ?? 0) > 0) {
          this.ensureTurnosLoaded();
        }

        this.ensureEtapasLoaded();
      },

      ensureGerenciasLoaded() {
        if (this.isLoadingGerencias || this.listaGerenciasRegionais.length > 0) {
          return;
        }

        this.isLoadingGerencias = true;
        CacheService.getOrFetch('formacao:gres',
          () => this.$obterListaGerenciasRegionais()
        )
          .then((resp) => {
            this.listaGerenciasRegionais = resp.data?.lista || [];
          })
          .catch(err => {
            console.error('Erro ao buscar GREs:', err);
          })
          .finally(() => {
            this.isLoadingGerencias = false;
          });
      },

      ensureSecretariasLoaded() {
        if (this.isLoadingSecretarias || this.listaSecretarias.length > 0) {
          return;
        }

        this.isLoadingSecretarias = true;
        CacheService.getOrFetch('formacao:secretarias',
          () => this.$obterListaSecretarias()
        )
          .then((resp) => {
            this.listaSecretarias = resp.data?.lista || [];
          })
          .catch(err => {
            console.error('Erro ao buscar secretarias:', err);
          })
          .finally(() => {
            this.isLoadingSecretarias = false;
          });
      },

      ensureDisciplinasLoaded() {
        if (this.isLoadingDisciplinas || this.disciplinas.length > 0) {
          return;
        }

        this.isLoadingDisciplinas = true;
        CacheService.getOrFetch('formacao:disciplinas',
          () => this.$buscarDisciplina()
        )
          .then((resp) => {
            this.disciplinas = resp.data?.lista?.filter(disciplina => disciplina?.ativo) || [];
          })
          .catch(err => {
            console.error('Erro ao buscar disciplinas:', err);
          })
          .finally(() => {
            this.isLoadingDisciplinas = false;
          });
      },

      ensureAvaliacoesLoaded() {
        if (this.isLoadingAvaliacoes || this.avaliacoes.length > 0) {
          return;
        }

        this.isLoadingAvaliacoes = true;
        CacheService.getOrFetch('formacao:avaliacoes',
          () => this.$buscarAvaliacaoFormacao({ params: {situacao: true, tipoAvaliacao: 2} })
        )
          .then((resp) => {
            this.avaliacoes = resp.data?.itens || [];
          })
          .catch(err => {
            console.error('Erro ao buscar avaliações:', err);
          })
          .finally(() => {
            this.isLoadingAvaliacoes = false;
          });
      },

      ensureTurnosLoaded() {
        if (this.isLoadingTurnos || this.listaTurnos.length > 0) {
          return;
        }

        this.isLoadingTurnos = true;
        CacheService.getOrFetch('formacao:turnos',
          () => this.$obterTurnos().catch(err => {
            console.error('Erro ao buscar turnos:', err);
            return { data: { lista: [] } };
          })
        ).then((turnosResp) => {
          this.listaTurnos = turnosResp.data?.lista || [];
        }).finally(() => {
          this.isLoadingTurnos = false;
        });
      },

      ensureEtapasLoaded() {
        if (this.isLoadingEtapas || this.listaEtapas.length > 0) {
          return;
        }

        this.isLoadingEtapas = true;
        CacheService.getOrFetch('formacao:etapas',
          () => this.$obterEtapas().catch(err => {
            console.error('Erro ao buscar etapas:', err);
            return { data: { lista: [] } };
          })
        ).then((etapasResp) => {
          this.listaEtapas = etapasResp.data?.lista || [];
        }).finally(() => {
          this.isLoadingEtapas = false;
        });
      },

      carregarEscolas() {
        if (this.liberarEscola && this.listarEscolas.length === 0) {
          // Implementar lógica de carregamento de escolas quando necessário
        }
      },

      formatarCargaHoraria(value) {
        let digitos = value.replace(/\D/g, '');
        let valorRealString = parseInt(digitos, 10).toString();
        if (valorRealString === 'NaN') {
          valorRealString = '';
        }
        const digitosLimitados = valorRealString.slice(0, 5);
        const digitosPreenchidos = digitosLimitados.padStart(5, '0');
        const valorFormatado = `${digitosPreenchidos.slice(0, 3)}:${digitosPreenchidos.slice(3)}`;
        
        this.$nextTick(() => {
          this.content.cargaHoraria = valorFormatado
          this.$forceUpdate();
        })
      },
      solicitarCorrecao() {
        const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
        if (this.jaSofreuTresAjustes) {
          this.$emit('changeTab', 1);
          return;
        }
        this.$swal({
            text: `Deseja confirmar essa operação?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
          }).then((result) => {
            if (result) {
              const payload = {
                comentario: this.content.comentario
              };
              const numeroDaAba = 1;
              return this.$solicitarCorrecao(formacaoId, numeroDaAba, payload);
            }
          }).then(({ data }) => {
            if (data && !this.content.id && data.formacaoId) {
              globalStore.setFormacaoIdCriado(data.formacaoId);
            }
            this.$notifySuccess(data.mensagem);
            this.$emit("onSave");
            this.$emit('changeTab', 1);
          }
        );
      },
      isReenviar(){
        return globalStore.isReenviarSolicitacao;
      },
      async atualizarGreIds() {
        if (this.content.greId) {
          try {
            const idSelecionado = this.content.greId.codigo || this.content.greId;
            this.liberarEscola = !!idSelecionado;
            this.consultandoEscolasViaGre([idSelecionado]);
          } catch (error) {
            this.$notifyError("Erro ao buscar escolas:", error);
          }
        } else {
          this.listarEscolas = [];
          this.liberarEscola = false;
        }
      },
      construirPayload() {
        const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
        const { 
            id, origemId, greId, escolaId, secretariaId, dataInicio, dataFim, 
            funcaoId, etapaDeEnsinoId, disciplinaId, nomeDaAcao, objetivoGeral, 
            objetivoEspecifico, localRealizacao, numeroTotalParticipantes, 
            quantidadeDeTurmas, cargaHoraria, conteudoProgramatico, 
            metodologiaDeEnsino, recursosUtilizados, valorTotalInvestimento, 
            instrutores, coordenadores, relacaoTurmas, avaliacaoId 
        } = this.content;
        return {
            id,
            formacaoId,
            origemId: origemId.id,
            gre: greId ? { codigo: greId.codigo || greId, nome: greId.nome || greId.nome } : null,
            escolas: escolaId?.map(escola => ({
              id: escola.id,
              codigo: escola.codigo,
              nome: escola.nome,
              codigoGre: escola.codigoGre
            })) || [],
            secretarias: Array.isArray(secretariaId) ? secretariaId : secretariaId ? [secretariaId] : [],
            dataInicio,
            dataFim,
            funcaoId,
            etapaId: etapaDeEnsinoId,
            disciplinaId,
            avaliacaoId,
            nome: nomeDaAcao,
            objetivoGeral,
            objetivosEspecificos: objetivoEspecifico,
            localRealizacao,
            numeroTotalParticipantes,
            quantidadeDeTurmas,
            cargaHoraria,
            conteudoProgramatico,
            metodologiaDeEnsino,
            recursosUtilizados,
            valorTotalInvestimento: valorTotalInvestimento 
              ? parseFloat(valorTotalInvestimento.replace(/R\$|\./g, '').replace(',', '.')).toFixed(2) 
              : null,
            instrutores: instrutores?.map(instrutor => ({
                id: instrutor.id,
                nome: instrutor.nomeDoInstrutor,
                matricula: instrutor.matriculaDoInstrutor,
                cpf: this.$unMask(instrutor.cpfDoInstrutor)
            })) || [],
            coordenadores: coordenadores?.map(coordenador => ({
                id: coordenador.id,
                nome: coordenador.nomeDoCoordenador,
                matricula: coordenador.matriculaDoCoordenador,
                cpf: this.$unMask(coordenador.cpfDoCoordenador)
            })) || [],
            turmas: relacaoTurmas?.map(turma => ({
                id: turma.id,
                turma: turma.nomeTurma,
                dataRealizacao: turma.dataRealizacao,
                turnoId: turma.turnoId || null,
                horaInicio: turma.horaInicio ? `${turma.horaInicio}:00` : null,
                horaFim: turma.horaTermino ? `${turma.horaTermino}:00` : null,
            })) || []
        };
      },
      salvar(fecharTela) {
        if (this.$validarFormulario("Preencha todos os campos obrigatórios!")) {
        
          if (
            !this.content.relacaoTurmas?.length || 
            !this.content.instrutores?.length || 
            !this.content.coordenadores?.length
          ) {
            this.$notifyError("Selecione ao menos uma Turma, um Coordenador e um Instrutor!");
            return;
          }
          this.$swal({
            text: `Confirma os dados de Plano de Trabalho da Solicitação de Formação?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            }).then(() => {
                const payload = this.construirPayload();
                const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
                return formacaoId
                    ? this.$editarFormacao(formacaoId, payload)
                    : this.$cadastrarFormacao(payload);
            }).then(({ data }) => {
              if (!this.content.id && data.formacaoId) {
                    globalStore.setFormacaoIdCriado(data.formacaoId);
                }
                this.$notifySuccess(data.mensagem);
                this.$emit("onSave");
                if (fecharTela) {
                    this.$emit('changeTab', 1);
                }                 
            });
          }
        },
      cancelar() {
        if (
          !this.isFormador &&
          this.content.comentario !== this.comentarioInicial &&
          !this.isViewMode
        ) {
          return this.fechar();
        }
        this.$emit('onClose');
        globalStore.limpar();
      },
      fechar() {
        return this.$swal({
            text: "Ao fechar sem salvar, as informações inseridas serão perdidas. Tem certeza que deseja continuar?",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
        }).then((result) => { 
            if (result) {
              this.$emit('onClose');
              globalStore.limpar();
            }
        });
      },
      avancar() {
        this.$emit('changeTab', 1);
      },
      excluirTurma(turma) {
        this.$swal({
          text: `Deseja confirmar a exclusão da turma?`,
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result) {
            this.content.relacaoTurmas = this.content.relacaoTurmas.filter(t => t !== turma);
            this.$set(this.content, "quantidadeDeTurmas", this.content.relacaoTurmas.length);
            this.$notifySuccess("Turma removida com sucesso.");
          }
        });
      },
      editarTurma(item, index) {
        if (!this.content.relacaoTurmas || !item?.nomeTurma) {
          return;
        }
        this.turmaEditandoIndex = index;
        this.$set(this.content, 'nomeTurma', item.nomeTurma);
        this.content.turnoId = this.listaTurnos.find(turno => turno.descricao === item.nomeTurno) || null;
        this.content.horaInicio = this.formatarHora(item.horaInicio);
        this.content.horaTermino = this.formatarHora(item.horaTermino);
        this.content.dataRealizacao = item.dataRealizacao?.split("T")[0];
        this.$forceUpdate();
      },
      adicionarAtualizarTurma() {
        if (!this.content.nomeTurma || !this.content.horaInicio || !this.content.horaTermino || !this.content.turnoId.turnoId || !this.content.dataRealizacao) {
          return;
        }
        if (this.horaValida(this.content.horaInicio) !== true || this.horaValida(this.content.horaTermino) !== true) {
        this.$notifyError("Os horários inseridos são inválidos. Por favor, informe no formato HH:MM.");
        return;
        }
        if (!this.validarHorarios()) {
          return;
        }
        if (!this.validarDataRealizacao()) {
          this.$notifyError("A Data deve estar entre a Data Início da Formação e a Data Final da Formação.");
          return;
        }
        
        if (!this.content.relacaoTurmas) {
          this.$set(this.content, "relacaoTurmas", []);
        }

        if (this.turmaEditandoIndex !== null) {
          this.$set(this.content.relacaoTurmas, this.turmaEditandoIndex, {
            nomeTurma: this.content.nomeTurma,
            nomeTurno: this.content.turnoId.descricao,
            turnoId: this.content.turnoId.turnoId,
            dataRealizacao: this.content.dataRealizacao,
            horaInicio: this.content.horaInicio ? `${this.content.horaInicio}` : null,
            horaTermino: this.content.horaTermino ? `${this.content.horaTermino}` : null,
          });
          this.turmaEditandoIndex = null;
        } else {
          if (this.content.relacaoTurmas.length < 15) {
            this.content.relacaoTurmas.push({
              nomeTurma: this.content.nomeTurma,
              nomeTurno: this.content.turnoId.descricao,
              turnoId: this.content.turnoId.turnoId,
              dataRealizacao: this.content.dataRealizacao,
              horaInicio: this.content.horaInicio ? `${this.content.horaInicio}` : null,
              horaTermino: this.content.horaTermino ? `${this.content.horaTermino}` : null,
            });
            this.$set(this.content, "relacaoTurmas", [...this.content.relacaoTurmas]);
            this.$set(this.content, "quantidadeDeTurmas", this.content.relacaoTurmas.length);
          } else {
            this.$notifyError("Você só pode adicionar até 15 turmas.");
          }
        }
        this.$set(this.content, "relacaoTurmas", [...this.content.relacaoTurmas]);
        this.resetFormTurma();
        

      },
      resetFormTurma() {
        this.content.nomeTurma = "";
        this.content.horaInicio = '';
        this.content.horaTermino = '';
        this.content.turnoId = { turnoId: null, descricao: "" };
        this.content.dataRealizacao = "";
        this.$forceUpdate();
      },
      validateData() {
        if (!this.content.dataInicio || !this.content.dataFim) return true;

        const dataInicio = new Date(this.content.dataInicio);
        const dataFim = new Date(this.content.dataFim);

        if (dataInicio > dataFim) {
            return false;
        }
        return true;
      },
      validarDataRealizacao() {
        if (!this.content.dataRealizacao || !this.content.dataInicio || !this.content.dataFim) return false;

        const dataInicio = new Date(this.content.dataInicio);
        const dataFim = new Date(this.content.dataFim);
        const dataRealizacao = new Date(this.content.dataRealizacao);

        if (dataRealizacao < dataInicio || dataRealizacao > dataFim) {
            return false;
        }
        return true;
      },
      horaValida(h) {
        if (!h) return true;
        const [hora, minuto] = h.split(':').map(Number);

        if (isNaN(hora) || isNaN(minuto)) {
          return 'Hora inválida';
        }

        if (!/^\d{2}:\d{2}$/.test(h)) {
          return;
        }

        const condicao = hora >= 0 && hora <= 23 && minuto >= 0 && minuto <= 59;
        return condicao ? true : 'Hora inválida';
      },
      validarHorarios() {
        if (!this.content.horaInicio || !this.content.horaTermino) return false;

        const [horaInicio, minutoInicio] = this.content.horaInicio.split(":").map(Number);
        const [horaTermino, minutoTermino] = this.content.horaTermino.split(":").map(Number);

        const inicio = horaInicio * 60 + minutoInicio;
        const termino = horaTermino * 60 + minutoTermino;

        if (inicio >= termino) {
          this.$notifyError("O horário de início deve ser anterior ao horário de término. Por favor, ajuste os horários informados.");
          return false;
        }

        return true;
      },
      formatarHoraInput(campo, event) {
        let value = event;
        value = value.replace(/\D/g, '');

        if (value.length > 2) {
          value = value.slice(0, 2) + ':' + value.slice(2, 4);
        }

        this.content[campo] = value;
        this.$forceUpdate();
      },
      validarFormatoHora(hora) {
        if(!hora)return true;
        return /^\d{2}:\d{2}$/.test(hora);
      },
      horaNoTurnoEspecificado(h) {
        if (!h || !this.content.turnoId) return true;
        const [horaStr, minutoStr] = h.split(":")
        if(!horaStr || !minutoStr) return true;

        const hora = Number(horaStr);
        const minuto = Number(minutoStr);

        const [horaInicioPermitido, minutoInicioPermitido] = this.horarioPermitido?.inicio.split(":").map(Number);
        const [horaFimPermitido, minutoFimPermitido] = this.horarioPermitido?.fim.split(":").map(Number);

        const horarioInicioPermitido = horaInicioPermitido * 60 + minutoInicioPermitido
        const horarioFimPermitido = horaFimPermitido * 60 + minutoFimPermitido
        const horario = hora * 60 + minuto

        const condicao = horario >= horarioInicioPermitido && horario <= horarioFimPermitido;

        return condicao 
          ? true
          : `O horário deve estar entre ${this.horarioPermitido?.inicio} e ${this.horarioPermitido?.fim} para o turno ${this.turnoSelecionado.descricao}.`;
      },
      formatarHora(hora) {
        if (!hora) return "";
        const partes = hora.split(":");
        if (partes.length >= 2) {
          return `${partes[0]}:${partes[1]}`;
        }
        return hora;
      },
      excluirCoordenador(coordenador) {
        this.$swal({
          text: `Deseja confirmar a exclusão do Coordenador?`,
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result) {
            this.content.coordenadores = this.content.coordenadores.filter(t => t !== coordenador);
            this.$forceUpdate();
            this.$notifySuccess("Coordenador removido com sucesso.");
          }
        });
      },
      editarCoordenador(item, index) {
        if (!this.content.coordenadores || !item?.nomeDoCoordenador) {
          return;
        }

        this.coordenadorEditandoIndex = index;
        this.$set(this.content, 'nomeDoCoordenador', item.nomeDoCoordenador);
        this.$set(this.content, 'matriculaDoCoordenador', item.matriculaDoCoordenador);
        this.content.cpfDoCoordenador = this.$formatCpf(item.cpfDoCoordenador);
        this.$forceUpdate();
      },
      adicionarAtualizarCoordenador() {
        if (!this.content.nomeDoCoordenador || !this.content.matriculaDoCoordenador || !this.content.cpfDoCoordenador) {
          return;
        }
        const valueCpf = this.content.cpfDoCoordenador.replace(/\D/g, '');
        if(!this.$validarCPFs(valueCpf)) {
          return this.$notifyError("CPF do coordenador inválido!");
        }   
        if (!this.content.coordenadores) {
          this.$set(this.content, "coordenadores", []);
        }
        const cpfJaExiste = this.content.coordenadores.some(coordenador => coordenador.cpfDoCoordenador === this.content.cpfDoCoordenador);
        if (cpfJaExiste && this.coordenadorEditandoIndex === null) {
          return this.$notifyError("Este coordenador já foi adicionado!");
        }
        if (this.coordenadorEditandoIndex !== null) {
          this.$set(this.content.coordenadores, this.coordenadorEditandoIndex, {
            nomeDoCoordenador: this.content.nomeDoCoordenador,
            matriculaDoCoordenador: this.content.matriculaDoCoordenador,
            cpfDoCoordenador: this.content.cpfDoCoordenador
          });
          this.turmaEditandoIndex = null;
        } else {
          this.content.coordenadores.push({
            nomeDoCoordenador: this.content.nomeDoCoordenador,
            matriculaDoCoordenador: this.content.matriculaDoCoordenador,
            cpfDoCoordenador: this.content.cpfDoCoordenador
          });
          this.$set(this.content, "coordenadores", [...this.content.coordenadores]);
        }
        this.$set(this.content, "coordenadores", [...this.content.coordenadores]);
        this.resetFormCoordenador();
      },
      validarHorarioTurno() {
        this.$refs.formHoraInicio.validate()
        this.$refs.formHoraFinal.validate()
      },
      validarPegarNumeros(event) {
        const textoPuro = event.clipboardData.getData('Text').replace(/\D/g, '');
        this.content.cpfDoCoordenador = textoPuro;
      },
      validarFormatoCargaHoraria(v) {
        if(!v) return true;
        const [horas, minutos] = v.split(':').map(Number);

        const horasValidas = 0 <= horas && horas <= 999;
        const minutosValidos = 0 <= minutos && minutos < 60;

        return horasValidas && minutosValidos ? true : 'O campo Carga Horária deve estar no formato HH:MM, com minutos entre 00 e 59.';
      },
      resetFormCoordenador() {
        this.content.nomeDoCoordenador = "";
        this.content.matriculaDoCoordenador = "";
        this.content.cpfDoCoordenador = "";
        this.$forceUpdate();
      },
      excluirInstrutor(instrutor) {
        this.$swal({
          text: `Deseja confirmar a exclusão do Instrutor?`,
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result) {
            this.content.instrutores = this.content.instrutores.filter(t => t !== instrutor);
            this.$forceUpdate();
            this.$notifySuccess("Instrutor removido com sucesso.");
          }
        });
      },
      editarInstrutor(item, index) {
        if (!this.content.instrutores || !item?.nomeDoInstrutor) {
          return;
        }

        this.instrutorEditandoIndex = index;
        this.$set(this.content, 'nomeDoInstrutor', item.nomeDoInstrutor);
        this.$set(this.content, 'matriculaDoInstrutor', item.matriculaDoInstrutor);
        this.content.cpfDoInstrutor = this.$formatCpf(item.cpfDoInstrutor);
        this.$forceUpdate();
      },
      
      adicionarAtualizarInstrutor() {
        if (!this.content.nomeDoInstrutor || !this.content.matriculaDoInstrutor || !this.content.cpfDoInstrutor) {
          return;
        }
        const valueCpf = this.content.cpfDoInstrutor.replace(/\D/g, '');
        if(!this.$validarCPFs(valueCpf)) {
          return this.$notifyError("CPF do instrutor inválido!");
        }        
        if (!this.content.instrutores) {
          this.$set(this.content, "instrutores", []);
        }
        const cpfJaExiste = this.content.instrutores.some(instrutor => instrutor.cpfDoInstrutor === this.content.cpfDoInstrutor);
        if (cpfJaExiste && this.instrutorEditandoIndex === null) {
          return this.$notifyError("Este instrutor já foi adicionado!");
        }
        if (this.instrutorEditandoIndex !== null) {
          this.$set(this.content.instrutores, this.instrutorEditandoIndex, {
            nomeDoInstrutor: this.content.nomeDoInstrutor,
            matriculaDoInstrutor: this.content.matriculaDoInstrutor,
            cpfDoInstrutor: this.content.cpfDoInstrutor
          });
          this.instrutorEditandoIndex = null;
        } else {
          this.content.instrutores.push({
            nomeDoInstrutor: this.content.nomeDoInstrutor,
            matriculaDoInstrutor: this.content.matriculaDoInstrutor,
            cpfDoInstrutor: this.content.cpfDoInstrutor
          });
          this.$set(this.content, "instrutores", [...this.content.instrutores]);
        }
        this.$set(this.content, "instrutores", [...this.content.instrutores]);
        this.resetFormInstrutor();
      },
      resetFormInstrutor() {
        this.content.nomeDoInstrutor = "";
        this.content.matriculaDoInstrutor = "";
        this.content.cpfDoInstrutor = "";
        this.$forceUpdate();
      },
      verificarOrigemSelecionada() {
        this.mostrarNomeGre = false;
        this.mostrarSecretariaExecutiva = false;
        this.mostrarEscola = false;

        const origemSelecionada = this.content.origemId;

        if (origemSelecionada && origemSelecionada.nome) {
            const nomeOrigem = origemSelecionada.nome.toUpperCase();

            if (nomeOrigem === "GRE") {
                this.mostrarNomeGre = true;
            } else if (nomeOrigem === "SEE") {
                this.mostrarSecretariaExecutiva = true;
            } else if (nomeOrigem === "ESCOLA") {
                this.mostrarEscola = true;
                this.mostrarNomeGre = true;
            }
        }
      },
      consultandoEscolasViaGre() {
        this.$obterListaEscolas({ gres: this.content.greId.codigo || this.content.greId})
          .then(({ data }) => {
            this.listarEscolas = data.lista;
          }
        );
      },
      formatarValor(event) {
        let value = event;
        value = value.replace(/\D/g, '');
        if (value.length > 2) {
          value = value.slice(0, -2) + '.' + value.slice(-2);
        } else if (value.length === 2) {
          value = '0.' + value;
        } else if (value.length === 1) {
          value = '0.0' + value;
        } else {
          value = '0.00';
        }

        value = parseFloat(value).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        this.content.valorTotalInvestimento = value;
        this.$forceUpdate();
      },
      formatarCpfOnInput(campo, event) {
        let value = event.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos
        if (value.length > 11) {
          value = value.slice(0, 11); // Limita a 11 dígitos (CPF sem máscara)
        }
        // Aplica a máscara manualmente
        if (value.length > 3 && value.length <= 6) {
          value = value.replace(/(\d{3})(\d+)/, '$1.$2');
        } else if (value.length > 6 && value.length <= 9) {
          value = value.replace(/(\d{3})(\d{3})(\d+)/, '$1.$2.$3');
        } else if (value.length > 9) {
          value = value.replace(/(\d{3})(\d{3})(\d{3})(\d+)/, '$1.$2.$3-$4');
        }
        this.$set(this.content, campo, value); // Atualiza o valor no modelo
      },
      preencherCampos() {
        if (!globalStore.dadosPlanoDeTrabalho) {
            return;
        }
        const dados = globalStore.dadosPlanoDeTrabalho; 

        // Garantir que o situacaoId do globalStore está sincronizado
        if (dados.situacaoId != null) {
          globalStore.setSituacaoId(dados.situacaoId);
        }

        this.content.id = dados.id ?? null;
        this.content.formacaoId = dados.formacaoId ?? null;
        this.content.origemId = dados.origem ?? null;
        this.content.dataInicio = dados.dataInicio ? new Date(dados.dataInicio).toISOString().split('T')[0] : null;
        this.content.dataFim = dados.dataFim ? new Date(dados.dataFim).toISOString().split('T')[0] : null;
        this.content.funcaoId = dados.funcaoId ?? null;
        this.content.etapaDeEnsinoId = dados.etapaId ?? null;
        this.content.disciplinaId = dados.disciplinaId ?? null;
        this.content.avaliacaoId = dados.avaliacaoId ?? null;
        this.content.nomeDaAcao = dados.nome ?? null;
        this.content.objetivoGeral = dados.objetivoGeral ?? null;
        this.content.objetivoEspecifico = dados.objetivosEspecificos ?? null;
        this.content.localRealizacao = dados.localRealizacao ?? null;
        this.content.numeroTotalParticipantes = dados.numeroTotalParticipantes ?? null;
        this.content.cargaHoraria = dados.cargaHoraria ?? null;        
        this.content.conteudoProgramatico = dados.conteudoProgramatico ?? null;
        this.content.metodologiaDeEnsino = dados.metodologiaDeEnsino ?? null;
        this.content.recursosUtilizados = dados.recursosUtilizados ?? null;
        this.content.comentario = dados.comentario ?? null;
        this.comentarioInicial = this.content.comentario; 
        this.content.ultimaAtualizacao = dados.ultimaAtualizacao ?? null;
        this.content.valorTotalInvestimento = dados.valorTotalInvestimento ?? "0,00";
        this.formatarValor(parseFloat(this.content.valorTotalInvestimento.replace(',', '.')).toFixed(2).replace('.', ','));
        this.content.relacaoTurmas = dados.turmas?.map(turma => ({
            id: turma.id ?? null,
            nomeTurma: turma.turma ?? null,
            dataRealizacao: turma.dataRealizacao ?? null,
            turnoId: turma.turnoId ?? null,
            nomeTurno: turma.turno ?? null,
            horaInicio: this.formatarHora(turma.horaInicio) ?? null,
            horaTermino: this.formatarHora(turma.horaFim) ?? null
        })) ?? [];
        this.content.instrutores = dados.instrutores?.map(instrutor => ({
            id: instrutor.id ?? null,
            nomeDoInstrutor: instrutor.nome ?? null,
            matriculaDoInstrutor: instrutor.matricula ?? null,
            cpfDoInstrutor: instrutor.cpf ?? null
        })) ?? [];
        this.content.coordenadores = dados.coordenadores?.map(coordenador => ({
            id: coordenador.id ?? null,
            nomeDoCoordenador: coordenador.nome ?? null,
            matriculaDoCoordenador: coordenador.matricula ?? null,
            cpfDoCoordenador: coordenador.cpf ?? null
        })) ?? [];
        this.content.gre = dados.gre ? {
            id: dados.gre.id ?? null,
            codigo: dados.gre.codigo ?? null,
            nome: dados.gre.nome ?? null
        } : null;
        this.content.escolas = dados.escolas?.map(escola => ({
            id: escola.id ?? null,
            codigo: escola.codigo ?? null,
            nome: escola.nome ?? null,
            codigoGre: escola.codigoGre ?? null
        })) ?? [];

        this.content.secretariaId = dados.secretarias ?? [];
        this.content.greId = dados.gre ?? null;
        this.content.escolaId = dados.escolas ?? [];
        this.$nextTick(() => {
            this.sincronizarOrigemSelecionada();
            this.verificarOrigemSelecionada();
            this.atualizarGreIds();
            this.$forceUpdate();
        });
      }
    },
    async mounted() {
      await this.carregarDadosEssenciais();
      this.isInitializing = false;
      this.carregarDadosSecundarios();
    }
  };
</script>
<style scoped>
.alert-message {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
</style>